/**
 * Clive: stop the PDP from scrolling to the variant's image when a variant is picked.
 *
 * Stiletto's stacked desktop gallery calls scrollIntoView() on the selected
 * variant's featured image (theme.js ~7070, and again from the "more media"
 * expander ~5264). On a long gallery that pulls the page away from the price,
 * Customize drawer and Add to Bag the shopper was just using (Dani, 2026-10-05).
 *
 * Patched here rather than in theme.js so it survives Stiletto updates. Only a
 * scrollIntoView() on a gallery media item ([data-media-id] inside
 * .product__media-container) is skipped — every other scrollIntoView on the site
 * runs as normal. The variant still selects, and the gallery still marks and
 * expands to its image; the page just stays where the shopper is.
 */
(function () {
  'use strict';

  var original = Element.prototype.scrollIntoView;
  if (typeof original !== 'function') return;

  Element.prototype.scrollIntoView = function () {
    if (
      this.matches &&
      this.matches('[data-media-id]') &&
      this.closest('.product__media-container')
    ) {
      return;
    }
    return original.apply(this, arguments);
  };
})();
